import api from "../utils/api";

export const login = async (email, password) => {
  try {
    const response = await api.post("/api/account/login", {
      username: email,
      password,
    });
    return response.data; // { accessToken, refreshToken }
  } catch (error) {
    throw new Error(error.response?.data?.message || "Login failed");
  }
};

export const register = async (data) => {
  const res = await api.post(`api/account/register`, data);

  if (!res.ok) {
    const errorData = await res.json();
    throw new Error(errorData.message || "Registration failed");
  }

  return res.json();
};

export const refreshAccessToken = async (refreshToken) => {
  try {
    const response = await api.post("/api/account/refresh-token", {
      refreshToken,
    });
    return response.data; // { accessToken }
  } catch (error) {
    throw new Error(error.response?.data?.message || "Token refresh failed");
  }
};

export const resetPassword = async (payload) => {
  try {
    const response = await api.put("/api/account/reset-password", payload);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Reset Password failed.");
  }
};

export const logoutSession = async () => {
  const payload = {
    username: JSON.parse(localStorage.getItem("userDetails")).username || "",
    refreshToken: localStorage.getItem("refreshToken") || "",
  };
  try {
    const response = await api.post("/api/account/logout-session", payload);
    return response.data;
  } catch (error) {
    //throw new Error(error.response?.data?.message || "Reset Password failed.");
  }
};

export const getUserDetailsByEmail = async (userName) => {
  try {
    const response = await api.get(`/api/account/get/${userName}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Data fetch failed.");
  }
};

export const getUserDetailsById = async (userId) => {
  try {
    const response = await api.get(`/api/account/get/${userId}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Data fetch failed.");
  }
};

export const getAllUsers = async (roles, excludeRoles, excludeUsers) => {
  try {
    let response = await api.get(`/api/account/list`);
    if (roles && roles.length > 0) {
      response.data = response.data.filter((x) =>
        roles.includes(x.userRole.id)
      );
    }
    if (excludeRoles && excludeRoles.length > 0) {
      response.data = response.data.filter(
        (x) => !excludeRoles.includes(x.userRole.id)
      );
    }
    if (excludeUsers && excludeUsers.length > 0) {
      response.data = response.data.filter((x) => !excludeUsers.includes(x.id));
    }

    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Data fetch failed.");
  }
};
